import axios from "axios"
import store from "@/store";
import router from "@/router";

const http = axios.create({
    baseURL: "/api",
    timeout: 10000
})

let isRelogin = false

// ---- 租户编码（多租户 SaaS：请求头 X-Tenant-Code）----
const TENANT_CODE_KEY = 'tenantCode'

export function getTenantCode() {
    return localStorage.getItem(TENANT_CODE_KEY) || ''
}

export function setTenantCode(code) {
    if (code) {
        localStorage.setItem(TENANT_CODE_KEY, code)
    } else {
        localStorage.removeItem(TENANT_CODE_KEY)
    }
}

function getUserToken() {
    if (store.state.token) {
        return store.state.token
    } else {
        return ""
    }
}

// Add a request interceptor
http.interceptors.request.use(function (config) {
    // Do something before request is sent
    config.headers['authorization'] = '' + getUserToken(); // 替换
    const tenantCode = getTenantCode()
    if (tenantCode) {
        config.headers['X-Tenant-Code'] = tenantCode
    }
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
http.interceptors.response.use(function (response) {
    if (response.data && (response.data.code === 402 || response.data.code === 401)) {
        if (!isRelogin) {
            isRelogin = true
            store.commit('doOnLogout')
            router.push('/login')
        }
        // 会话失效已由拦截器统一处理（跳登录页），promise 置为永不落定，
        // 避免组件 catch 里的 showNetErrMsg 再弹"网络发生故障"误导排查
        return new Promise(() => {});
    }
    return response;
}, function (error) {
    // 网络层失败（无响应：代理掐断空闲连接/DNS 抖动等，请求未达服务端）自动重试一次，
    // 消除偶发「网络发生故障」；服务端明确返回的错误（有 response）不重试
    if (!error.response && error.config && !error.config.__netRetried) {
        error.config.__netRetried = true;
        return http.request(error.config);
    }
    if (error.response && error.response.data) {
        const code = error.response.data.code
        if (code === 402 || code === 401) {
            if (!isRelogin) {
                isRelogin = true
                store.commit('doOnLogout')
                router.push('/login')
            }
            return new Promise(() => {});
        }
    }
    return Promise.reject(error);
});

export const configJson = {
    headers: {
        'Access-Control-Allow-Origin': '*',  //解决cors头问题
        'Content-Type': 'application/json'
    }
}

export const configForm = {
    headers: {
        'Access-Control-Allow-Origin': '*',  //解决cors头问题
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' //将表单数据传递转化为form-data类型
    }
}

export default http
